import { Flex, Button, Text, Separator } from "@chakra-ui/react";
import CartList from "@features/marketplace/cart/CartList";
import { useCallback } from "react";
import { useStores } from "stores/rootStore";
import { useRouter } from "next/navigation";
import { observer } from "mobx-react-lite";

interface CartSummaryProps {
  onContinueShopping: () => void;
}

const CartSummary = ({ onContinueShopping }: CartSummaryProps) => {
  const { marketPlaceStore } = useStores();
  const router = useRouter();
  const isCartEmpty = marketPlaceStore.cart.length === 0;

  const handleContinueToCheckout = useCallback(() => {
    router.push(`/checkout/${marketPlaceStore.cartId}`);
  }, [marketPlaceStore.cart, router]);

  return (
    <Flex flexDirection={"column"} gap={4} h={"100%"} w={"100%"} pb={4}>
      <Flex w={"100%"} overflowY={"scroll"} flex={1}>
        <CartList />
      </Flex>
      {marketPlaceStore.cart.length > 0 && (
        <>
          <Separator />
          <Flex justifyContent={"space-between"}>
            <Text>Subtotal</Text>
            <Text fontSize={"lg"} fontWeight={"bold"}>
              GHS{marketPlaceStore.cartTotal}
            </Text>
          </Flex>
          <Separator />
        </>
      )}
      <Flex flexDirection={"column"} gap={4}>
        <Button variant={"outline"} onClick={onContinueShopping}>
          Continue shopping
        </Button>
        <Button
          disabled={isCartEmpty}
          w={"100%"}
          onClick={handleContinueToCheckout}
        >
          Continue to checkout
        </Button>
      </Flex>
    </Flex>
  );
};

export default observer(CartSummary);
